export default __webpack_public_path__ + "static/media/roadmap.1bda163a.svg";